document.addEventListener("DOMContentLoaded", function () {
  const STORAGE_KEY = "wishlist";

  function getWishlist() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function toggleWishlist(handle) {
    let list = getWishlist();

    if (list.includes(handle)) {
      list = list.filter((h) => h !== handle);
    } else {
      list.push(handle);
    }

    saveWishlist(list);
    return list;
  }

  function updateHeart(button, active) {
    if (active) {
      button.classList.add("active");
    } else {
      button.classList.remove("active");
    }
  }

  // Initialize hearts (for collection/product cards)
  document.querySelectorAll(".wishlist-btn").forEach((btn) => {
    const handle = btn.getAttribute("data-product-handle");
    if (!handle) return;
    updateHeart(btn, isInWishlist(handle));
  });

  // Global click for wishlist button
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".wishlist-btn");
    if (!btn) return;

    e.preventDefault();

    const handle = btn.getAttribute("data-product-handle");
    if (!handle) return;

    toggleWishlist(handle);

    const active = isInWishlist(handle);
    updateHeart(btn, active);

    // If wishlist page → remove card immediately
    if (!active && document.querySelector("#wishlist-container")) {
      const card = btn.closest(".product-card");
      if (card) card.remove();

      // If no items left show empty message
      if (document.querySelectorAll("#wishlist-container .product-card").length === 0) {
        document.querySelector("#wishlist-container").innerHTML =
          "<p>Your wishlist is empty.</p>";
      }
    }
  });

  // Wishlist Page rendering
  const wishlistContainer = document.querySelector("#wishlist-container");

  if (wishlistContainer) {
    const wishlist = getWishlist();

    if (wishlist.length === 0) {
      wishlistContainer.innerHTML = "<p>Your wishlist is empty.</p>";
      return;
    }

    wishlistContainer.innerHTML = "<p>Loading wishlist...</p>";

    const productRequests = wishlist.map((handle) =>
      fetch(`/products/${handle}.js`).then((res) => res.json())
    );

    Promise.all(productRequests)
      .then((products) => {
        let html = "";

        products.forEach((product) => {
          html += `
            <div class="product-card group color rounded-block">
              
              <div class="relative overflow-hidden group/media">
                
                <a href="${product.url}" tabindex="-1">
                  <div class="media rounded-block">
                    <img 
                      src="${product.featured_image}" 
                      alt="${product.title}"
                      class="product-card__image product-thumbnail-shade"
                      loading="lazy"
                    />
                  </div>
                </a>

                <!-- Heart Button -->
                <button
                  class="wishlist-btn absolute top-2 right-2 z-20 w-9 h-9 lg:w-12 lg:h-12 rounded-full bg-white/80 backdrop-blur flex items-center justify-center shadow-md hover:bg-white transition active"
                  type="button"
                  aria-label="Remove from wishlist"
                  data-product-handle="${product.handle}"
                >
                  <svg
                    class="wishlist-icon w-5 h-5 lg:w-6 lg:h-6"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21.2l7.8-7.8 1-1.1a5.5 5.5 0 0 0 0-7.7z"/>
                  </svg>
                </button>

              </div>

              <div class="product-card__info pt-5 md:pt-6 flex flex-col grow max-md:text-sm">
                
                <h2 class="product-name">
                  <a href="${product.url}">${product.title}</a>
                </h2>

                <div class="mt-2">
                  <span class="price">Rs. ${(product.price / 100).toFixed(2)}</span>
                </div>

              </div>
            </div>
          `;
        });

        wishlistContainer.innerHTML = html;

        // Update heart state properly
        document.querySelectorAll("#wishlist-container .wishlist-btn").forEach((btn) => {
          const handle = btn.getAttribute("data-product-handle");
          updateHeart(btn, isInWishlist(handle));
        });
      })
      .catch(() => {
        wishlistContainer.innerHTML = "<p>Unable to load wishlist products.</p>";
      });
  }
});
